<template>
    <div class="rd_content">
        <div class="rd_basicInfo_back">
            <!-- <div class="rd_back" @click="getBack()">&lt; 返回</div> -->
            <div class="rd_basicInfo">
                <div class="bi_state_time">
                    <div class="bi_company_title">【{{recruitDeail.Company}}】{{recruitDeail.Title}}</div>
                    <div class="bi_time">发布时间：{{recruitDeail.TimeDesc}}</div>
                </div>
                
                <div class="bi_officeModeName_workTypeName">
                    <div class="bi_officeModeName">{{recruitDeail.OfficeModeName}}</div>
                    <div class="bi_workTypeName">{{recruitDeail.WorkTypeName}}</div>
                </div>
                <div class="bi_officeModeName_salary">
                    <div class="bi_salary" v-if="recruitDeail.Salary!=''">薪资范围：{{recruitDeail.Salary}}</div>
                    <div class="bi_salary" v-else>薪资范围：{{recruitDeail.BasicSalary}} - {{recruitDeail.MaxSalary}}</div>
                </div>
                <div class="bi_welfareTreatment">福利待遇：{{recruitDeail.WelfareTreatment || '/'}}</div>
            </div>
        </div>
    
        <div class="rd_desc" v-if="recruitDeail.Content == ''">
            <div class="desc_label">招聘详情</div>

            <div class="article">
                <div class="article-body" >
                    <div class="article-intro" v-html="recruitDeail.Message"></div>
                </div>
            </div>
        </div>

        <div class="rd_desc" v-else-if="recruitDeail.Content != ''">
            <div class="desc_label">招聘详情</div>

            <div class="article">
                <div class="article-body">
                    <div class="article-intro">
                        <h1>【{{recruitDeail.Company}}】{{recruitDeail.Title}}</h1>
                        <h3>发布时间：{{recruitDeail.TimeDesc || '/'}}</h3>
                        <h2>职位描述：</h2>
                        <p>{{recruitDeail.TitleDescription || '/'}}</p>
                        <h2>职位要求：</h2>
                        <p>{{recruitDeail.TitleRequirements || '/'}}</p>
                        <h2>福利待遇：</h2>
                        <p>{{recruitDeail.WelfareTreatment || '/'}}</p>
                        <h2>办公方式：</h2>
                        <p>{{recruitDeail.OfficeModeName || '/'}}</p>
                        <h2>工作地点：</h2>
                        <p>{{recruitDeail.WorkLocation || '/'}}</p>
                        <h2>工作类型：</h2>
                        <p>{{recruitDeail.WorkTypeName || '/'}}</p>
                        <h2>薪酬范围：</h2>
                        <p>{{recruitDeail.Salary || '/'}}</p>
                        <h2>联系方式：</h2>
                        <p>{{recruitDeail.ContactInfo || '/'}}</p>
                        <h2>公司介绍：</h2>
                        <p>{{recruitDeail.Introduction || '/'}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/config/font-awesome.css'
import '@/config/style.css'
import { getJobDetail } from "@/config/api.js";
export default {
    data() {
        return {
            recruitDeail: {}
        }
    },
    beforeMount() {
        var that = this;
        var queryData = this.$route.query;
        if (queryData.hasOwnProperty("article")) {
            that.requestGetJobDetail(queryData.article);
        }
    },
    methods: {
        // 查询jobDetail
        requestGetJobDetail(article) {
            var that = this;
            var params = {
                article: article,
            };
            getJobDetail(params).then((res) => {
                if (res.data) {
                    that.recruitDeail = res.data;
                }
            });
        },
        // 返回上一页
        getBack() {
            var that = this;
            that.$router.go(-1);
        }
    }
}
</script>

<style lang="scss" scoped>
.rd_content {
    width: 100%;
    min-height: 100vh;
    height: auto;
    background: #F6F6F6;
    padding: 60px 0 18px 0;

    .rd_basicInfo_back {
        width: 100%;
        height: 254px;
        background: linear-gradient( 357deg, #0740AD 0%, #000000 100%);
        padding: 26px 18.75% 0 18.75%;

        display: flex;
        justify-content: center;

        .rd_back {
            width: 80px;
            height: 32px;
            border-radius: 30px 30px 30px 30px;
            border: 1px solid #FFFFFF;

            font-family:  2.0,  20;
            font-weight: normal;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 30px;
            text-align: center;
            font-style: normal;
            text-transform: none;

            cursor: pointer;

            margin: 0 88px 0 0;
        }

        .rd_basicInfo {
            width: calc(100%);
            height: 100%;

            .bi_state_time {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .bi_company_title {
                    font-family:  2.0,  20;
                    font-weight: normal;
                    font-size: 36px;
                    color: #FFFFFF;
                    line-height: 42px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .bi_time {
                    font-family:  2.0,  20;
                    font-weight: normal;
                    font-size: 22px;
                    color: #FFFFFF;
                    line-height: 32px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }



            .bi_officeModeName_workTypeName {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin: 14px 0 0 0;

                .bi_officeModeName {
                    width: auto;
                    height: 24px;
                    background: #EDF3FF;
                    border-radius: 6px 6px 6px 6px;

                    padding: 0 8px 0 8px;
                    font-family:  2.0,  20;
                    font-weight: normal;
                    font-size: 14px;
                    color: #1867FF;
                    line-height: 24px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;

                    margin: 0 16px 0 0;
                }

                .bi_workTypeName {
                    width: auto;
                    height: 24px;
                    background: #EDF3FF;
                    border-radius: 6px 6px 6px 6px;

                    padding: 0 8px 0 8px;
                    font-family:  2.0,  20;
                    font-weight: normal;
                    font-size: 14px;
                    color: #1867FF;
                    line-height: 24px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                }
            }

            .bi_officeModeName_salary {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                margin: 26px 0 0 0;

                .bi_salary {
                    font-family:  2.0,  20;
                    font-weight: normal;
                    font-size: 24px;
                    color: #B5FF88;
                    line-height: 34px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                    margin: 0 107px 0 0;
                }

                .bi_officeModeName2 {
                    font-family:  2.0,  20;
                    font-weight: normal;
                    font-size: 24px;
                    color: #B5FF88;
                    line-height: 34px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            
            .bi_welfareTreatment {
                font-family:  2.0,  20;
                font-weight: normal;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 34px;
                text-align: left;
                font-style: normal;
                text-transform: none;

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                margin: 23px 0 0 0;
            }
        }
    }

    .rd_desc {
        width: auto;
        height: auto;
        min-height: 608px;
        background: #FFFFFF;
        box-shadow: 0px 14px 20px 0px rgba(20,65,153,0.05);
        border-radius: 8px 8px 8px 8px;

        margin: 18px 18.75% 0 18.75%;
        padding: 39px 47px 39px 47px;

        .desc_label {
            font-family:  2.0,  20;
            font-weight: normal;
            font-size: 24px;
            color: #689BFF;
            line-height: 34px;
            text-align: left;
            font-style: normal;
            text-transform: none;

            margin: 0 0 23px 0;
        }
    }

}

@media screen and (max-width: 958px){
    .rd_content {
        width: 100%;
        min-height: 100vh;
        height: auto;
        background: #F6F6F6;
        padding: 60px 0 18px 0;

        .rd_basicInfo_back {
            width: 100%;
            height: 152px;
            background: linear-gradient( 357deg, #0740AD 0%, #000000 100%);
            padding: 13px 5% 0 5%;

            display: flex;
            justify-content: center;

            .rd_back {
                width: 60px;
                height: 24px;
                border-radius: 15px 15px 15px 15px;
                border: 1px solid #FFFFFF;

                font-family:  2.0,  20;
                font-weight: normal;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 22px;
                text-align: center;
                font-style: normal;
                text-transform: none;

                cursor: pointer;

                margin: 0 22px 0 0;
            }

            .rd_basicInfo {
                width: calc(100%);
                height: 100%;

                .bi_state_time {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-flow: wrap;

                    .bi_company_title {
                        font-weight: normal;
                        font-size: 20px;
                        color: #FFFFFF;
                        line-height: 26px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;

                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .bi_time {
                        font-weight: normal;
                        font-size: 14px;
                        color: #FFFFFF;
                        line-height: 24px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }

                .bi_officeModeName_workTypeName {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin: 7px 0 0 0;

                    .bi_officeModeName {
                        width: auto;
                        height: 24px;
                        background: #EDF3FF;
                        border-radius: 6px 6px 6px 6px;

                        padding: 0 8px 0 8px;
                        font-family:  2.0,  20;
                        font-weight: normal;
                        font-size: 14px;
                        color: #1867FF;
                        line-height: 24px;
                        text-align: center;
                        font-style: normal;
                        text-transform: none;

                        margin: 0 16px 0 0;
                    }

                    .bi_workTypeName {
                        width: auto;
                        height: 24px;
                        background: #EDF3FF;
                        border-radius: 6px 6px 6px 6px;

                        padding: 0 8px 0 8px;
                        font-family:  2.0,  20;
                        font-weight: normal;
                        font-size: 14px;
                        color: #1867FF;
                        line-height: 24px;
                        text-align: center;
                        font-style: normal;
                        text-transform: none;
                    }
                }

                .bi_officeModeName_salary {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex-direction: column;

                    margin: 7px 0 0 0;

                    .bi_salary {
                        width: 100%;
                        font-family:  2.0,  20;
                        font-weight: normal;
                        font-size: 14px;
                        color: #B5FF88;
                        line-height: 20px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;

                        margin: 0 0 0 0;
                    }

                    .bi_officeModeName2 {
                        width: 100%;
                        font-family:  2.0,  20;
                        font-weight: normal;
                        font-size: 14px;
                        color: #B5FF88;
                        line-height: 20px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }
                
                .bi_welfareTreatment {
                    font-family:  2.0,  20;
                    font-weight: normal;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    margin: 0 0 0 0;
                }
            }
        }

        .rd_desc {
            width: auto;
            height: auto;
            min-height: 608px;
            background: #FFFFFF;
            box-shadow: 0px 14px 20px 0px rgba(20,65,153,0.05);
            border-radius: 8px 8px 8px 8px;

            margin: 18px 5% 0 5%;
            padding: 20px 24px 20px 24px;

            .desc_label {
                font-family:  2.0,  20;
                font-weight: normal;
                font-size: 18px;
                color: #689BFF;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;

                margin: 0 0 23px 0;
            }
        }
    }
}
</style>